export default __webpack_public_path__ + "static/media/daily-pause-stat-tile-stars.c065afb9.svg";